// THE DEPLOYED VERSION (v1_821), inlined by CRA from REACT_APP_BUILD_VERSION,
// which scripts/build-version.cjs writes before every build (the commit
// subject's version tag and the short commit). Never a fixed string: a build
// without it says so.
export const BUILD_VERSION = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BUILD_VERSION) || 'unversioned build';
